import { Loader } from '@mantine/core'
import type React from 'react'

interface CircleLoadingProps {
  size?: 'small' | 'medium' | 'large'
  color?: string | 'main' | 'sub'
  className?: string
}

const SIZE_MAP: Record<'small' | 'medium' | 'large', number> = {
  small: 16,
  medium: 24,
  large: 48,
}

export const CircleLoading: React.FC<CircleLoadingProps> = ({ size = 'medium', color = 'main', className }) => {
  const resolvedColor =
    color === 'main' ? 'var(--mantine-color-primary-5)' : color === 'sub' ? 'var(--sub-color)' : color

  return <Loader size={SIZE_MAP[size]} color={resolvedColor} className={className} aria-label="読み込み中" />
}
